import {
  Create,
  Datagrid,
  Edit,
  List,
  SaveButton,
  SimpleForm,
  TextField,
  FunctionField,
  TextInput,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
} from "react-admin";

import UploadFile from "./components/upload-file";
import { useState } from "react";
import DocViewer from "./components/docViwer";
import BulkUploadKnowledgeManager from "./components/bulk-upload-knowledge-manager";

const KnowledgeManagerListActions = () => (
  <TopToolbar>
    <CreateButton />
    <BulkUploadKnowledgeManager />
    <ExportButton />
  </TopToolbar>
);

export const KnowledgeManagerList = (props) => {
  const [docviewer, setDocViewer] = useState(false);
  const [url, setUrl] = useState();
  return (
    <>
      {docviewer && <DocViewer url={url} setDocViewer={setDocViewer} />}
      <List pagination={false} actions={<KnowledgeManagerListActions />}>
        <Datagrid bulkActionButtons={false}>
          <TextField source="pageContent" />
          <FunctionField
            label="File"
            render={(record) =>
              record.metadata?.fileUrl ? (
                <div>
                  <button
                    onClick={(e) => (
                      setUrl(
                        decodeURIComponent(record.metadata?.fileUrl)
                      ),
                      setDocViewer(true)
                    )}
                    className="border border-gray-500 p-2 rounded-md bg-green-100 text-gray-600 hover:bg-primary hover:text-white"
                  >
                    Open
                  </button>
                </div>
              ) : (
                "N/A"
              )
            }
          />
          <FunctionField
            label="Source File"
            render={(record) =>
              record.metadata?.sourceFileUrl ? (
                <div>
                  <button
                    onClick={(e) => (
                      setUrl(
                        decodeURIComponent(record.metadata?.sourceFileUrl)
                      ),
                      setDocViewer(true)
                    )}
                    className="border border-gray-500 p-2 rounded-md bg-green-100 text-gray-600 hover:bg-primary hover:text-white"
                  >
                    Open
                  </button>
                </div>
              ) : (
                "N/A"
              )
            }
          />
          <FunctionField
            label="Source Url"
            render={(record) =>
              record.metadata?.sourceUrl ? (
                <a
                  className="border border-gray-500 p-2 rounded-md bg-green-100 text-gray-600 hover:bg-primary hover:text-white w-16"
                  href={record.metadata?.sourceUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Go
                </a>
              ) : (
                "N/A"
              )
            }
          />
          <FunctionField
            label="File Name"
            render={(record) => `${record.metadata.source.split("/").pop()} `}
          />
          <DeleteButton mutationMode="pessimistic" />
        </Datagrid>
      </List>
    </>
  );
};

export const KnowledgeManagerCreate = (props) => {
  return (
    <Create title="Add supervisors " {...props} redirect="list">
      <SimpleForm>
        <p className="mb-4 after:content-['*'] after:ml-0.5 after:text-red-500 ">
          Main File
        </p>
        <div className="mb-6 w-full rounded-lg p-2 border border-green-600 text-center ">
          <UploadFile key="1" name="fileUrl" />
        </div>
        <p className="mb-4">Source File :</p>
        <div className="mb-6 w-full rounded-lg p-2 border border-green-600 text-center ">
          <UploadFile key="2" name="sourceFileUrl" />
        </div>
        <p className="mb-4">External Source Link :</p>
        <TextInput source="sourceUrl" label="source Link" fullWidth />
        <p className="text-sm italic text-gray-500 -m-5 ml-5 pb-6">
          example: https://en.wikipedia.org/wiki/Tomato
        </p>
      </SimpleForm>
    </Create>
  );
};

